import clsx from "clsx";
import { useGetProperties } from "../../../base/hooks";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { ControlType, Property } from "../../../base/types";
import { MUIIcon } from "../../../widgets";
import { TouUmsLinkProperties } from "./properties/TouUmsLinkProperties";
import { useUmsUrl } from "../../page-actions/services/useTouUrl";
import { FC } from "react";


export const UMSLinkComponent: FC<IControlAttributes> = ({
    control,
    className,
    children,
    props,
    designerMode,
    ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const { umsUrl } = useUmsUrl()
    const target: string | undefined = properties[Property.Target];
    const title: string | undefined = properties[Property.Title];

    if (!umsUrl)
        return <></>

    return (
        <>
            <div>
                <a target={target || undefined} href={umsUrl}>
                    <span className={className}>{title}</span>
                    {children}
                </a>

            </div>
        </>
    );
};

Registry.addControl({
    id: "c857b558-92b2-4ee8-a2aa-a2eb2e905880",
    name: "UMSLinkComponent",
    type: ControlType.UMSLink,
    properties: TouUmsLinkProperties,
    component: UMSLinkComponent,
})

